(ns motorsaif.web.pages.ops.index
  (:require
   [motorsaif.web.components :as c]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.shared.ops :as shared-ops]
   [motorsaif.web.pages.ops.components :as comps-ops]
   [re-frame.core :as rf]))

(defn categories []
  [:div.categories-section
   [:div.header "Conversation Sections"]
   (into
    [:div.categories-list]
    (map (fn [{:keys [title desc n category icon trend-text trend-up]}]
           (let [sub @(rf/subscribe [(keyword :ops category)])
                 n (count sub)]
             ^{:key title}
             [:a.item
              {:href (routes/path-for :ops-category {:category (name category)})
               :class (name category)}
              [:div.content
               [:div.left
                [:div.icon-wrapper
                 [:div.icon icon]]
                [:div.details
                 [:div.title title]
                 [:div.subtitle desc]
                 #_[:div.trend-indicator {:class (when-not trend-up "down")}
                    [:span.trend-arrow (if trend-up [:i.fa-solid.fa-arrow-trend-up] [:i.fa-solid.fa-arrow-trend-down])]
                    [:span trend-text]]]]
               [:div.count n]]]))
         (filter #(not (#{:past-deadline :urgent} (:category %))) shared-ops/categories)))])

(defn past-deadline [items]
  [:section.past-deadline.priority-section
   [:div.header
    [:div.icon [:i.fa-solid.fa-alarm-clock]]
    [:div.title "Past Deadline"]
    [:div.count (count items)]]
   [:div.items
    (for [item (take 2 items)]
      ^{:key (:db/id item)}
      [comps-ops/preview-item item])]
   [:a.btn.accent.full
    {:href (routes/path-for :ops-category {:category :past-deadline})}
    "View All Past Deadline"]])

(defn most-urgent [items]
  [:section.urgent.priority-section
   [:div.header
    [:div.icon [:i.fa-solid.fa-fire-flame-curved]]
    [:div.title "Most Urgent"]
    [:div.count (count items)]]
   [:div.items
    (for [item (take 2 items)]
      ^{:key (:db/id item)}
      [comps-ops/preview-item item])]
   [:a.btn.accent.full
    {:href (routes/path-for :ops-category {:category :urgent})}
    "View All Urgent"]])

(defn root []
  (let [past-deadline-items @(rf/subscribe [:ops/past-deadline])
        urgent-items @(rf/subscribe [:ops/urgent])
        biz-name (:business/name @(rf/subscribe [:current-owner]))]
    [:div#ops
     [c/header "Operations"
      {:subtitle biz-name}]
     [:div.content.container-sm
      (when (seq past-deadline-items)
        [past-deadline past-deadline-items])
      (when (seq urgent-items)
        [most-urgent urgent-items])
      [categories]]]))
